import { render, staticRenderFns } from "./discord-followup-form.vue?vue&type=template&id=24ce4ace&lang=pug&"
import script from "./discord-followup-form.vue?vue&type=script&lang=js&"
export * from "./discord-followup-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports